import React from 'react';
import { NavigationDots, SocialMedia } from '../components';

const AppWrap = (Component, idName, classNames) => function HOC() {
    return (
        <div id={idName} className={`app__container ${classNames}`}>
            <SocialMedia />
            <div className="app__wrapper app__flex">
                <Component />

                <div className="copyright">
                    <p className="p-text">© {new Date().getFullYear()} <a href="https://www.talents-handicap.com" target="_blank" rel="noopener noreferrer">Talents Handicap</a></p>
                    <p className="p-text">Tous les droits réservés</p>
                </div>
            </div>
            <NavigationDots active={idName} />
        </div>
    );
};

export default AppWrap;
